/* global ajax_url js_lang */
((window, $) => {
  const form = $('#form-noresults');
  const send = () => {
    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: form.serialize(),
      dataType: 'json',
      success(data) {
        const alert = $('#no-result-alert');
        if (data.code === 1) {
          $('#no-results_product-name').val('');
          $('#no-results_email').val('');
          alert.removeClass('alert-warning');
          alert.addClass('alert-success');
        } else {
          alert.removeClass('alert-success');
          alert.addClass('alert-warning');
        }
        const alertText = $('#no-result-alert .fs-14');
        alertText.html('');
        alertText.html(data.msg);
        if (!alert.hasClass('show')) {
          alert.addClass('show');
        }
      },
    });
  };
  form.validate({
    errorClass: 'validation-error',
    rules: {
      searchTerm: { required: true },
      searchLocation: { required: true },
      requesterEmail: { required: true, email: true },
    },
    messages: {
      searchTerm: { required: js_lang.product_name_required },
      searchLocation: { required: js_lang.location_name_required },
      requesterEmail: { required: js_lang.email_required, email: js_lang.email_invalid },
    },
    errorPlacement(label, element) {
      if (element.data('bs.tooltip')) { element.tooltip('dispose'); }
      element.tooltip({
        title: label.text(),
        placement: 'bottom',
        template:
          `<div class="validation-tooltip tooltip" role="tooltip">
            <div class="arrow"></div>
            <div class="tooltip-inner" style="width:${element.width()}px"></div>
        </div>`,
      });
    },
    success(label, element) {
      $(element).tooltip('dispose');
    },
    submitHandler() {
      send();
      return false;
    },
  });
})(window, window.jQuery);

